import { Tools } from './map-tools.control';
import { h, render } from 'preact';

export function renderToolsComponent(map, markersService, geofenceService, toolsControlOptions) {
    render(
        <Tools
            map={map}
            markersService={markersService}
            geofenceService={geofenceService}
            options={toolsControlOptions}
        />,
        map.getContainer().parentElement
    );
}
